// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 505 ? "haptics" : chunkId) + "." + {"182":"4e236fc4","239":"e39fb35b","455":"492e6b75","505":"f04be807","578":"4c46475d","977":"459ae33c"}[chunkId] + ".chunk.js";
};